<template>
  <div>
    <v-main>
      <div
        class="col-md-12 ml-sm-auto col-lg-12 pa-4"
        v-show="dataintab === true"
      >
        <v-row class="pb-3">
          <v-col>
            <h2>รายงานข้อมูลแพ็กเกจ</h2>
          </v-col>
          <v-col
            class="text-right mb-4"
            v-if="session.data.userTypeGroup !== 'Operation'"
          >
            <v-btn
              class="btn-color"
              v-on="on"
              color="indigo"
              outlined
            >
              <download-excel
                class="btn btn-default text-white"
                :data="tab === 2 ? dataItem4 : dataItem3"
                :fields="tab === 2 ? export_fields2 : export_fields"
                :type="exportType"
                :worksheet="exportWorksheet"
                :name="exportFileName"
                style="display: flex"
              >
                <v-icon color="indigo">
                  mdi-download
                </v-icon>
                <p class="mb-0 indigo--text" >Export Data</p>
              </download-excel>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="pb-3 mt-5 ma-0 w-100 col-grid" v-if="tab === 2">
          <div class="pa-0">
            <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="date2"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    label="ค้นหาตามวันที่"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @click:clear="clearTextField()"
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date2" no-title scrollable range>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu2 = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.menu2.save(date2)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
          </div>
          <div class="pa-0">
            <v-text-field
              v-model="memberSearch"
              label="ค้นหา ชื่อ / เบอร์โทร"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              clearable
              hide-details
            ></v-text-field>
          </div>
          <v-btn class="btn-grid" color="indigo" dark @click.stop="getDataPackageTransactionMember()">ค้นหา</v-btn>
        </v-row>
        <v-card>
          <v-tabs v-model="tab" color="#1b437c">
            <v-tab v-if="session.data.userTypeGroup !== 'partner'">
              <h4>แพ็กเกจทั้งหมด</h4>
            </v-tab>
            <v-tab v-if="session.data.userTypeGroup !== 'partner'">
              <h4>แพ็กเกจที่ขายได้</h4>
            </v-tab>
            <v-tab>
              <h4>ประวัติการใช้แพกเกจ</h4>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item v-if="session.data.userTypeGroup !== 'partner'">
              <v-data-table
                :headers="columns"
                :items="dataItem"
                :items-per-page="10"
                class="elevation-1"
                style="padding-top: 10px"
              >
                <template v-slot:[`item.LAST_DATE`]="{ item }">
                  {{ thaiFormattedDate(item.LAST_DATE) }}
                </template>
                <template v-slot:[`item.packagePrice`]="{ item }">
                  {{ formatNumber(item.packagePrice) }}
                </template>
                <template v-slot:[`item.packageExpri`]="{ item }">
                  {{ item.packageExpri }}
                </template>
                <template v-slot:[`item.packageImg`]="{ item }">
                  <v-avatar color="primary" size="40">
                    <img :src="item.packageImg" alt="img"
                  /></v-avatar>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item v-if="session.data.userTypeGroup !== 'partner'">
              <v-data-table
                :headers="columns1"
                :items="dataItem1"
                :items-per-page="10"
                class="elevation-1"
                style="padding-top: 10px"
              >
                <template v-slot:[`item.packageImg`]="{ item }">
                  <v-avatar color="primary" size="40">
                    <img :src="item.packageImg" alt="img"
                  /></v-avatar>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="btn-color"
                        fab
                        dark
                        small
                        @click="
                          (dialogPackageMember = true),
                            (dataintab = false),
                            getDataPackageMember(item);
                        "
                      >
                        <v-icon dark> mdi-account-multiple-outline </v-icon>
                      </v-btn>
                    </template>
                    <span>ลูกค้าที่ใช้แพ็กเกจ</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item>
              <v-data-table
                :headers="columns3"
                :items="dataItem4"
                :search="memberSearch"
                :custom-filter="memberFilter"
                :items-per-page="10"
                style="padding-top: 10px"
              >
                <template v-slot:[`item.packageImg`]="{ item }">
                  <v-avatar color="primary" size="40">
                    <img :src="item.packageImg" alt="img"
                  /></v-avatar>
                </template>
                <template v-slot:[`item.picture`]="{ item }">
                  <v-avatar color="primary" size="40">
                    <img :src="item.picture" alt="img"
                  /></v-avatar>
                </template>
                <template v-slot:[`item.adminUser`]="{ item }">
                  {{
                    item.adminUser === "None" || item.adminUser === null
                      ? "-"
                      : item.adminUser
                  }}
                </template>
                <template v-slot:[`item.CREATE_DATE`]="{ item }">
                  {{ thaiFormattedLAST_Date(item.CREATE_DATE) }}
                </template>
                <template v-slot:[`item.balanceAmount`]="{ item }">
                  {{ showDecimal(item.balanceAmount) }}
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </div>
      <div
        class="col-md-12 ml-sm-auto col-lg-12 px-4"
        v-show="dialogPackageMember === true"
      >
        <v-row style="padding-top: 15px; padding-bottom: 15px">
          <v-col style="padding: 15px 16px 0px">
            <h3>ลูกค้าที่ใช้บริการ</h3>
          </v-col>
          <v-col class="text-right">
            <v-btn
              small
              fab
              color="#E0E0E0"
              @click="
                (dialogPackageMember = false),
                  (dataintab = true),
                  clearSearch();
              "
            >
              <v-icon color="#173053">mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <div class="col-grid">
          <div>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText2"
                  label="ค้นหาตามวันที่"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  @click:clear="clearTextField()"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" no-title scrollable range>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(date)">
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>
          <div>
            <v-text-field
              label="ค้นหารายชื่อ"
              outlined
              dense
              v-model="nameSearch"
            ></v-text-field>
          </div>
          <div class="mx-auto d-flex btn-grid">
            <div class="me-2">
              <v-btn dark @click="search()">ค้นหา</v-btn>
            </div>
            <div
            cols="2"
            class="text-right mb-4 btn-grid"
            v-if="session.data.userTypeGroup !== 'Operation'"
          >
            <v-btn
              class="btn-color"
              v-on="on"
              color="indigo"
              outlined
            >
            <download-excel
                class="btn btn-default text-white"
                :data="dataItem2"
                :fields="export_fields2"
                :type="exportType"
                :worksheet="exportWorksheet"
                :name="exportFileName"
                style="display: flex"
              >
                <v-icon color="indigo">
                  mdi-download
                </v-icon>
                <p class="mb-0 indigo--text" >Export Data</p>
              </download-excel>
            </v-btn>
          </div>
          </div>

        </div>

        <v-row>
          <v-col>
            <v-data-table
              :headers="columns2"
              :items="dataItem2"
              :items-per-page="10"
              class="elevation-1"
              style="padding-top: 10px"
            >
              <template v-slot:[`item.picture`]="{ item }">
                <v-avatar color="primary" size="40">
                  <img :src="item.picture" alt="img"
                /></v-avatar>
              </template>
              <template v-slot:[`item.CREATE_DATE`]="{ item }">
                {{ thaiFormattedLAST_Date(item.CREATE_DATE) }}
              </template>
              <template v-slot:[`item.exPackage`]="{ item }">
                {{ convertExpirePackage(item) }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment' // แปลง date
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx'
import memberSearch from '@/mixins/memberSearch'
export default {
  mixins: [memberSearch],
  components: {
    moment,
    downloadExcel: JsonExcel,
    XLSX
  },
  data () {
    return {
      menu: false,
      PK: '',
      path: '/package/', // Path Model
      PATH: '/packageQRcode/',
      returnLink: '/Master/Package',
      session: this.$session.getAll(),
      tab: null,
      dialogPackageMember: false,
      valid: true,
      menu1: false,
      dataintab: true,
      startDate: '',
      endDate: '',
      columns: [
        { text: 'รูป', value: 'packageImg' },
        { text: 'แพ็กเกจ', value: 'packageName' },
        {
          text: 'จำนวนการใช้งาน/ครั้ง',
          value: 'packageCount',
          align: 'center'
        },
        { text: 'ราคา', value: 'packagePrice', align: 'center' },
        { text: 'คะแนนที่ได้ต่อครั้ง', value: 'packagePoint', align: 'center' },
        { text: 'รายละเอียด', value: 'packageDetail' },
        { text: 'อายุการใช้งาน', value: 'packageExpridate', align: 'center' }
      ],
      itemExpri: [
        { text: '3 เดือน', value: '3' },
        { text: '6 เดือน', value: '6' },
        { text: '9 เดือน', value: '9' },
        { text: '1 ปี', value: '12' }
      ],
      columns1: [
        { text: 'รูปแพกเกจ', value: 'packageImg' },
        { text: 'แพ็กเกจ', value: 'packageName' },
        {
          text: 'จำนวนการขาย',
          value: 'count',
          align: 'center'
        },
        {
          text: 'ลูกค้าที่ซื้อแพ็กเกจ',
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ],
      columns2: [
        { text: 'รูป', value: 'picture' },
        { text: 'ชื่อไลน์ลูกค้า', value: 'name' },
        { text: 'แพ็กเกจ', value: 'packageName' },
        {
          text: 'จำนวนครั้งที่ใช้ได้',
          value: 'amount',
          align: 'center'
        },
        {
          text: 'จำนวนครั้งที่เหลือ',
          value: 'balanceAmount',
          align: 'center'
        },
        {
          text: 'วันที่ซื้อแพ็กเกจ',
          value: 'CREATE_DATE',
          align: 'center'
        },
        {
          text: 'วันหมดอายุ',
          value: 'exPackage',
          align: 'center'
        }
      ],
      dataItem1: [],
      columns3: [
        { text: 'รูปแพกเกจ', value: 'packageImg' },
        { text: 'ชื่อแพ็กเกจ', value: 'packageName' },
        // { text: 'รูปไลน์ลูกค้า', value: 'picture' },
        { text: 'ชื่อไลน์ลูกค้า', value: 'name' },
        { text: 'ชื่อลูกค้า', value: 'nameCustomer' },
        { text: 'เบอร์โทรศัพท์', value: 'tel' },
        { text: 'จำนวนที่ใช้', value: 'balanceAmount' },
        { text: 'ผู้รับผิดชอบ', value: 'displayName' },
        {
          text: 'วันที่ใช้แพกเกจ',
          value: 'CREATE_DATE',
          align: 'center'
        }
      ],
      dataItem2: [],
      dataItem3: [],
      dataItem4: [],
      date: [],
      date2: [],
      menu2: false,
      idPackage: '',
      nameSearch: '',
      exportType: 'xls',
      exportFileName: 'Report_Package',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        lineUserId: 'lineUserId',
        เบอร์โทรศัพท์: {
          field: 'tel',
          callback: (value) => {
            let telString = value.toString()
            return telString.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
          },
          formatNumber: '@'
        },
        ชื่อไลน์: 'name',
        ชื่อ: 'nameCustomer',
        ชื่อแพ็กเกจ: 'packageName',
        ราคาแพ็กเกจ: 'packagePrice',
        จำนวนทั้งหมด: 'amount',
        จำนวนที่เหลือ: 'balanceAmount',
        วันหมดอายุแพ็กเกจ: {
          callback: (item) => {
            const expire = item.expirePackage
            if (expire === '') {
              return 'หมดอายุหลังจากใช้ครั้งแรก'
            }
            if (expire === null || expire === undefined || expire === 'None' || Number(expire) <= 0 || isNaN(Number(expire))) {
              return 'ไม่มีวันหมดอายุ'
            }
            return item.packageExpire
          }
        }
      },
      export_fields2: {
        lineUserId: 'userId',
        เบอร์โทรศัพท์: {
          field: 'tel',
          callback: (value) => {
            let telString = value.toString()
            return telString.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
          },
          formatNumber: '@'
        },
        ชื่อไลน์: 'name',
        ชื่อ: 'nameCustomer',
        ชื่อแพ็กเกจ: 'packageName',
        ราคาแพ็กเกจ: 'packagePrice',
        จำนวนที่เหลือ: 'balanceAmountPackageLog',
        ผู้รับผิดชอบ: 'adminUser',
        จำนวนที่ใช้: 'balanceAmount',
        วันที่ใช้: 'CREATE_DATE_EXCEL'
      }
    }
  },
  computed: {
    dateRangeText: {
      get () {
        return this.date2.join(' - ')
      },
      set (value) {
        this.date2 = value ? value.split(' - ') : []
      }
    },
    dateRangeText2: {
      get () {
        return this.date.join(' - ')
      },
      set (value) {
        this.date = value ? value.split(' - ') : []
      }
    }
  },

  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    await this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )
    this.convertExpridate()
    this.getDataReport()
    this.generateFileName()
    await this.getDataPackageLogMember()
    await this.getDataPackageTransactionMember()
  },
  methods: {
    convertExpirePackage (item) {
      const expire = item.expirePackage
      if (expire === '') {
        return 'หมดอายุหลังจากใช้ครั้งแรก'
      }
      if (expire === null || expire === undefined || expire === 'None' || Number(expire) <= 0 || isNaN(Number(expire))) {
        return 'ไม่มีวันหมดอายุ'
      }
      return this.thaiFormattedDate(item.exPackage)
    },
    generateFileName () {
      const date = moment().format('DDMMYYYY')
      this.exportFileName = `Report_Package_${date}.xls`
    },
    showDecimal (item) {
      if (item.split('.')[1] === '0') {
        return item.split('.')[0]
      } else {
        return item
      }
    },
    search () {
      this.dataItem2 = []
      if (this.date.length <= 0 && this.nameSearch === '') {
        axios
          .get(
            this.DNS_IP +
              '/PackageLog/get?shopId=' +
              this.session.data.shopId +
              '&packageId=' +
              this.idPackage
          )
          .then((res) => {
            if (res.data.status === false) {
              this.dataItem2 = []
            } else {
              this.dataItem2 = res.data
            }
          })
      } else if (this.date.length > 0 && this.nameSearch === '') {
        this.date.sort((date1, date2) => moment(date1).diff(moment(date2)))
        axios
          .get(
            this.DNS_IP +
              '/PackageLog/get?shopId=' +
              this.session.data.shopId +
              '&packageId=' +
              this.idPackage +
              '&LAST_DATE=' +
              this.date
          )
          .then((res) => {
            if (res.data.status === false) {
              this.dataItem2 = []
            } else {
              this.dataItem2 = res.data
            }
          })
      } else if (this.date.length <= 0 && this.nameSearch !== '') {
        axios
          .get(
            this.DNS_IP +
              '/PackageLog/get?shopId=' +
              this.session.data.shopId +
              '&packageId=' +
              this.idPackage +
              '&name=' +
              this.nameSearch
          )
          .then((res) => {
            if (res.data.status === false) {
              this.dataItem2 = []
            } else {
              this.dataItem2 = res.data
            }
          })
      } else if (this.date.length > 0 && this.nameSearch !== '') {
        this.date.sort((date1, date2) => moment(date1).diff(moment(date2)))
        axios
          .get(
            this.DNS_IP +
              '/PackageLog/get?shopId=' +
              this.session.data.shopId +
              '&packageId=' +
              this.idPackage +
              '&LAST_DATE=' +
              this.date +
              '&name=' +
              this.nameSearch
          )
          .then((res) => {
            if (res.data.status === false) {
              this.dataItem2 = []
            } else {
              this.dataItem2 = res.data
            }
          })
      }
    },
    async getDataReport () {
      this.dataItem1 = []

      await axios
        .get(
          this.DNS_IP +
            '/reportPackageQRcode/get?shopId=' +
            this.session.data.shopId +
            '&status=used'
        )
        .then((response) => {
          let rs = response.data
          this.dataItem1 = rs
          console.log('rs2', this.dataItem1)
        })
    },
    async getDataPackageMember (item) {
      this.idPackage = item.packageId
      this.dataItem2 = []
      console.log('item', item.packageId)
      await axios
        .get(
          this.DNS_IP +
            '/PackageLog/get?shopId=' +
            this.session.data.shopId +
            '&packageId=' +
            item.packageId
        )
        .then((res) => {
          this.dataItem2 = res.data
          console.log('test', this.dataItem2)
          // this.nameUser = res.data.name
        })
    },
    async getDataPackageTransactionMember () {
      try {
        this.dataItem4 = []
        await this.setDate()
        let sql = ''
        if (this.session.data.userTypeGroup === 'partner') {
          sql =
            this.DNS_IP +
            '/PackageTransaction/get?shopId=' +
            this.session.data.shopId +
            '&userId=' +
            this.session.data.userId
        } else {
          sql =
            this.DNS_IP +
            '/PackageTransaction/get?shopId=' +
            this.session.data.shopId
        }
        if (this.startDate && this.endDate) {
          sql += `&CREATE_DATE=${encodeURIComponent(`${this.startDate},${this.endDate}`)}`
        }
        await axios
          .get(sql)
          .then((res) => {
            console.log('res.datasadasdasd', res.data)
            this.dataItem4 = res.data
            if (Array.isArray(this.dataItem4)) {
              this.dataItem4.map((item) => {
                item.CREATE_DATE_EXCEL = this.thaiFormattedLAST_Date(
                  item.CREATE_DATE
                )
              })
            } else {
              this.dataItem4 = []
            }
            console.log('ddddd ดดดดด', this.dataItem4)
          })
          .catch((error) => console.log(error))
      } catch (error) {
        console.log('error', error)
      }
    },
    setDate () {
      this.startDate = ''
      this.endDate = ''
      if (this.date2.length === 2) {
        this.date2.sort()
        this.startDate = moment(this.date2[0]).format('YYYY-MM-DD')
        this.endDate = moment(this.date2[1]).format('YYYY-MM-DD')
      } else if (this.date2.length === 1) {
        this.startDate = moment(this.date2[0]).format('YYYY-MM-DD')
        this.endDate = moment(this.date2[0]).format('YYYY-MM-DD')
      }
    },
    async getDataPackageLogMember () {
      this.dataItem3 = []
      let sql = ''
      sql =
        this.DNS_IP +
        '/PackageLog/get?shopId=' +
        this.session.data.shopId +
        '&status=use'

      await axios.get(sql).then((res) => {
        this.dataItem3 = res.data
        console.log('this.dataItem3', this.dataItem3)
      })
    },
    convertExpridate () {
      let month = this.dataItem
      this.dataItem = []
      for (let i = 0; i < month.length; i++) {
        let d = month[i]
        if (d.packageExpri !== '') {
          if (d.packageExpri === '12') {
            d.packageExpridate = '1 ปี'
            this.dataItem.push(d)
          } else {
            d.packageExpridate = d.packageExpri + ' เดือน'
            this.dataItem.push(d)
          }
        } else {
          d.packageExpridate = ''
          this.dataItem.push(d)
        }
      }
    },
    clearSearch () {
      this.date = ''
      this.nameSearch = ''
    },
    clearTextField () {
      this.date2 = []
      this.getDataPackageTransactionMember()
    }
  }
}
</script>
<style scoped>
h3 {
  font-size: 18.72px !important;
}

.btn-grid {
  grid-column: sp;
    justify-self: stretch;
}

</style>



// WEBPACK FOOTER //
// src/components/Reports/reportPackage.vue